module.exports = __webpack_public_path__ + "static/drumster-extraimg1@2x-min-61f024b514272f88ec05fe571e73739b.png";